import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {


  constructor(private http: HttpClient) { }



  async executeHttpPostMethodSigned(userIdToken: string, urlString: string, formData:FormData): Promise<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${userIdToken}`
    });

    try {
      const response = await lastValueFrom(this.http.post(urlString, formData, { headers }));
      return response;
    } catch (error) {
      console.error('Error al enviar el archivo DICOM:', error);
      throw error;
    }
  }



}
